import React from 'react';
import Home from '../Home/Home';
import About from '../About/About';
import Skills from '../Skills/Skills';
import heroBg from '../../Assets/bg-hero-home.png';
import Projects from '../Projects/Projects';
import Testimonials from '../Testimonials/Testimonials';
import Contact from '../Contact/Contact';
import Test from '../Test/Test';
import Education from '../Education/Education';

const PageLayout = () => {
     return (
          <div>
               <div className=''>

                    <div className="  bg-cover bg-no-repeat bg-top   relative" style={{ backgroundImage: `url(${heroBg})` }}>
                         <Home />
                    </div>
                    <div className=' mx-auto'>
                         <About />
                         <Skills />
                         <Projects />
                         <Education/>
                         <Testimonials />
                         <Contact />
                         {/* <Test /> */}
                    </div>
               </div>
          </div>
     );
};

export default PageLayout;